import React from 'react';
import {Modal} from "react-bootstrap";
import { getIn } from "formik";

const DocumentPreviewModal = (props) => {
    return <Modal show={props.show} onHide={props.onHide} size="md" centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
            <div className={'w-100'}>
                <img style={{width: '100%' }} src={getIn(props.values, `documents.${props.index}.dataUrl`)}></img>
            </div>
        </Modal.Body>
    </Modal>
}

export default DocumentPreviewModal;